import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { Link } from "react-router-dom";
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Light from 'components/headers/light';
import LightAdmin from 'components/headers/lightAdmin';
import Footerr from "components/footers/Footer";
import ScrollToTop from "components/ScrollToTop";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SearchBar from "./SearchBar";

const HeaderRow = tw.div`flex justify-center items-center flex-col w-full`;
const Header = styled(SectionHeading)`
  width: 100%;                /* Occupy full width to allow text-center to work */
  text-align: center !important;
  font-size: 30px !important;
  font-weight: 600;           /* 'semi-bold' is usually 600 in CSS */
  font-family: 'Urbanist', sans-serif !important;
  line-height: 1.2;
  align-self: center;         /* Changed from flex-start to center */
  margin-left: 0;
  margin-bottom: 20px;        /* Added some breathing room above the search bar */
`;
const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 sm:pr-4 md:pr-4 lg:pr-6 xl:pr-6`;
const Card = tw(motion.a)`rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0 mb-0`;
const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-56 xl:h-64 bg-center relative rounded-t transition-transform duration-300 ease-in-out group-hover:scale-105`}
  background-size: contain;
  background-repeat: no-repeat;
  background-color: #fff;
`;
const CardButton = tw(PrimaryButtonBase)`text-sm flex justify-center items-center mt-4 rounded-full px-10 py-2`;
const CardButtonContainer = tw.div`flex justify-center items-center mt-2 w-auto`;
const CardTitle = tw.h5`text-lg text-center text-[#000000]`;
const CardPrice = tw.p`mt-2 font-semibold text-center text-[#4e7662] text-[14px]`;
const CardText = tw.div`text-center text-[#000000]`;

const Champoing = ({ heading = "Nos produits", products = [] }) => {
  const role = localStorage.getItem("role");
  const [shampoing, setShampoing] = useState([]);
  const [filteredShampoing, setFilteredShampoing] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`https://rehabwmg.online/api/champoing?lang=${i18n.language}`)
      .then((response) => response.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : [];
        setShampoing(list);
        setFilteredShampoing(list);
      })
      .catch((error) => console.error("Error fetching products:", error));
  }, [i18n.language]);

  const handleGoToProduct = (card) => {
    const productName = card.Name || "product";
    const slug = productName.replace(/\s+/g, "-").toLowerCase();
    navigate(`/product-details/${card.ProductID}-${slug}`);
  };

  const slugify = (nameObj) => {
    const name = typeof nameObj === "object"
      ? nameObj[i18n.language] || nameObj.fr || ""
      : nameObj || "";
    return name.trim().replace(/\s+/g, "-").toLowerCase();
  };

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
        
        {/* Updated SEO Meta Tags */}
        <title>Shampoing 1l 100% Naturel Rehab Bio Maroc</title>
        <meta name="description" content="Laissez-vous séduire par Shampoing 1l. Laissez-vous tenter par notre sélection authentique et certifiée. Faites-vous livrer rapidement au Maroc. Achetez en toute confiance." />
        <link rel="canonical" href="https://rehabbio.ma/Shampoing-1l" />

        {/* Updated Open Graph Tags */}
        <meta property="og:title" content="Shampoing 1l 100% Naturel Rehab Bio Maroc" />
        <meta property="og:description" content="Laissez-vous séduire par Shampoing 1l. Laissez-vous tenter par notre sélection authentique et certifiée. Faites-vous livrer rapidement au Maroc. Achetez en toute confiance." />
        <meta property="og:url" content="https://rehabbio.ma/Shampoing-1l" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content="Rehab Bio" />
        
        {/* Product Specific Metadata */}
        <meta property="product:brand" content="Rehab Bio" />
        <meta property="product:availability" content="in stock" />
        <meta property="product:condition" content="new" />
        
        <meta name="theme-color" content="#1b5e20" />
        <meta name="robots" content="index, follow" />
        
        {/* JSON-LD remains useful for structured data in search results */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "Shampoing 1l 100% Naturel Rehab Bio Maroc",
            "url": "https://rehabbio.ma/Shampoing-1l",
            "description": "Laissez-vous séduire par Shampoing 1l. Laissez-vous tenter par notre sélection authentique et certifiée."
          })}
        </script>
      </Helmet>

      <AnimationRevealPage>
        <ScrollToTop />
        {role === "supplier" ? <Light /> : role === "buyer" ? <LightAdmin /> : <Light />}
        <Container>
          <ContentWithPaddingXl>
            <HeaderRow>
              <Header><h3>{t("shampoo_heading")}</h3></Header>

              <SearchBar
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                language={i18n.language}
                allProducts={shampoing}
                onResults={setFilteredShampoing}
              />
            </HeaderRow>

            <br /><br />

            <TabContent>
              {shampoing.length === 0 ? (
                <p style={{ textAlign: "center", width: "100%", color: "#9ca3af" }}>
                  {i18n.language === "ar" ? "جاري التحميل..." : "Téléchargement en cours…"}
                </p>
              ) : filteredShampoing.length === 0 ? (
                <p style={{ textAlign: "center", width: "100%", color: "#9ca3af", marginTop: "2rem" }}>
                  {i18n.language === "ar" ? "لا توجد نتائج" : "Aucun produit trouvé"}
                </p>
              ) : (
                filteredShampoing.map((card, index) => (
                  <CardContainer key={index}>
                    <Link to={`/product-details/${card.ProductID}-${slugify(card.Name)}`}>
                      <Card className="group" initial="rest" whileHover="hover" animate="rest">
                        <div onClick={() => handleGoToProduct(card)} style={{ cursor: "pointer" }}>
                          <CardImageContainer imageSrc={`https://rehabwmg.online/storage/${card.image}`} />
                        </div>
                        <CardText>
                          <CardPrice>
                            {(role === "supplier" || role === "influenceur" )
                              ? `${card.distributeur_price} ${t("currency")}`
                              : `${card.user_price} ${t("currency")}`}
                          </CardPrice>
                          <CardTitle>
                            {typeof card.Name === "object"
                              ? card.Name[i18n.language] || card.Name.fr
                              : card.Name}
                          </CardTitle>
                          <CardText>{card.slug?.[i18n.language] && card.slug[i18n.language]}</CardText>
                          <CardButtonContainer>
                            <CardButton onClick={() => handleGoToProduct(card)}>
                              <i className="bi bi-cart-plus"></i>{t('add_to_cart')}
                            </CardButton>
                          </CardButtonContainer>
                        </CardText>
                      </Card>
                    </Link>
                  </CardContainer>
                ))
              )}
            </TabContent>
          </ContentWithPaddingXl>
        </Container>
        <Footerr />
      </AnimationRevealPage>
    </>
  );
};

export default Champoing;